"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userStatus = void 0;
/**
 * Identifier for the user status header
 */
// eslint-disable-next-line import/prefer-default-export
exports.userStatus = 'X-User-Status';
//# sourceMappingURL=user.js.map